import { horizontalScroll } from '../../js/front/components/horizontal-scroll';


document.querySelectorAll( '.b-categories-nav' ).forEach( ( block ) => {

	const currentPath = window.location.href;
	const buttons = block.querySelectorAll( 'a' );
	const matchedButtons = [];

	buttons.forEach( button => {

		if ( currentPath.includes( button.getAttribute( 'href' ) ) ) {

			matchedButtons.push( button );

		}

	} )

	matchedButtons.sort( ( a, b ) => {

		return b.getAttribute( 'href' ).length - a.getAttribute( 'href' ).length;

	} );

	if ( matchedButtons.length > 0 ) {

		matchedButtons[ 0 ].classList.add( 'current' );

	}

	horizontalScroll( '.b-post-categories-nav__inner' );

} );
